var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailerLargeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58528 0.5C0.893806 0.5 0.333252 1.06055 0.333252 1.75203V14.0488H1.03671C1.28907 16.0162 2.96999 17.5366 5.00602 17.5366C6.45518 17.5366 7.72445 16.7663 8.42675 15.6129C9.12905 16.7663 10.3983 17.5366 11.8475 17.5366C13.8835 17.5366 15.5644 16.0162 15.8168 14.0488H17.1658L18.6219 12.0813H29.6666V1.75203C29.6666 1.06055 29.106 0.5 28.4146 0.5H1.58528ZM6.95114 13.5346C6.95114 14.6088 6.08028 15.4797 5.00602 15.4797C3.93176 15.4797 3.06089 14.6088 3.06089 13.5346C3.06089 12.4603 3.93176 11.5894 5.00602 11.5894C6.08028 11.5894 6.95114 12.4603 6.95114 13.5346ZM11.8475 15.4797C12.9217 15.4797 13.7926 14.6088 13.7926 13.5346C13.7926 12.4603 12.9217 11.5894 11.8475 11.5894C10.7732 11.5894 9.90236 12.4603 9.90236 13.5346C9.90236 14.6088 10.7732 15.4797 11.8475 15.4797Z",
    fill: "#101013"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerLargeBlack);
export default __webpack_public_path__ + "static/media/TrailerLargeBlack.76af68c4cb157ec6f19335f8baa493b0.svg";
export { ForwardRef as ReactComponent };